import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent extends BaseClass<any> implements OnInit {

  public key: any;
  formData!: FormGroup;
  submitted = false;
  errors: any;
  oldPasswordTextType= false;
  newPasswordTextType= false;
  confirmPasswordTextType= false;
  @Input() isModal!: any;
  public bsModalRef!: BsModalRef;
  @Output() openLogin = new EventEmitter();

  constructor(public service: WebserviceService,
    public _common: CommonService,
    public _message: MessageService,
    public router: Router,
    private modalService: BsModalService,
    protected injector: Injector  ,
    private fb: FormBuilder) { 
      super(document);
    }

  ngOnInit(): void {
    this.formData = this.fb.group({
      old_password: ['', Validators.required],
      new_password: ['', [Validators.required, Validators.minLength(6)]],
      new_password_re: ['', Validators.required],
    }, {
      validator: this._common.mustMatch('new_password', 'new_password_re'),
    });
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  get f() {
    return this.formData.controls;
  }

  onSubmit() {
    this.submitted = true;
    // this.router.navigate(['/login']);
    // this.router.navigate(['/home']);
    
    // stop here if form is invalid
    if (this.formData.invalid) {
      return;
    }

    let req = this._common.JSON_to_URLEncoded(this.formData.value);
    this.getServices().Post(`${this.env.baseUrl + this.api.changePass}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          this._message.succmessage(res.data.message);
          this.formData.reset();
          if (this.key?.isModal) {      
            this.bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
            this.bsModalRef?.hide();
          }
          // this.openLogin.emit('')
        } else {
          this.errors = res.data;
          this._message.errmessage(res.error.message);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  toggleOldPasswordFieldTextType() {
    this.oldPasswordTextType = !this.oldPasswordTextType;
  }

  toggleNewPasswordFieldTextType() {
    this.newPasswordTextType = !this.newPasswordTextType;
  }

  toggleConfirmPasswordFieldTextType() {
    this.confirmPasswordTextType = !this.confirmPasswordTextType;
  }

}
